module.exports = __webpack_public_path__ + "static/media/hero-text-bg-static.d97ad213.svg";